import React, { useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import Ocrsupport from './Ocrsupport';
import FileUploadHistory from './FileUploadHistory';

const OCRUpload = () => {
  const [file, setFile] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [refreshUploads, setRefreshUploads] = useState(false);
  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type.startsWith("image/")) {
      setFile(selectedFile);
    } else {
      alert("Please select a valid image file.");
    }
  };

  const parseOcrText = (text) => {
    const lines = text.split('\n').map(line => line.trim()).filter(Boolean);
  
    let billNo = '';
    let billDate = '';
    let billAmount = '';
    let customerName = 'Dewyani International Ltd.'; // fallback
    let orderNo = '';
    let paymentAmount = '';
  
    // Extract Bill No & Order No
    const billLine = lines.find(line => /inv\s*no/i.test(line));
    if (billLine) {
      const invMatch = billLine.match(/Inv\s*No\s*([^\s]+)/i);
      const ordMatch = billLine.match(/ORD\s*No\s*([^\s]+)/i);
      if (invMatch) billNo = invMatch[1];
      if (ordMatch) orderNo = ordMatch[1];
    }
  
    // Extract Bill Date
    const dateLine = lines.find(line => /Date[:\s]/i.test(line));
    if (dateLine) {
      const dateMatch = dateLine.match(/Date[:\s]+(\d{2}\/\d{2}\/\d{2})/i);
      if (dateMatch) billDate = dateMatch[1];
    }
  
    // Extract Bill Amount
    const amountLine = lines.find(line => /gross amount/i.test(line) || /bill amount/i.test(line));
    if (amountLine) {
      const match = amountLine.match(/([\d]+\.\d{2})/);
      if (match) billAmount = `₹${match[1]}`;
    }
  
    // Extract Payment Amount
    const payLine = lines.find(line => /Payments[:\s]/i.test(line));
    if (payLine) {
      const match = payLine.match(/([\d]+\.\d{2})/);
      if (match) paymentAmount = `₹${match[1]}`;
    }
  
    return {
      billNo: billNo || 'N/A',
      orderNo: orderNo || 'N/A',
      customerName,
      billDate: billDate || 'N/A',
      billAmount: billAmount || 'N/A',
      paymentAmount: paymentAmount || 'N/A'
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage(null);

    if (!file) {
      setErrorMessage("No file selected.");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await fetch("/server/ocrfunction/ocrfunction", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      // window.location.reload();


      if (!data.extractedText) {
        setErrorMessage("No text found in the image.");
        setLoading(false);
        return;
      }

      console.log("Extracted Text:", data.extractedText);
      const extracted = parseOcrText(data.extractedText);
      setTableData([extracted]);
      setRefreshUploads(prev => !prev);

    } catch (error) {
      console.error("Upload failed:", error);
      setErrorMessage("OCR processing failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Sidebar>
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-white/60 z-[9999]">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-red-500 border-t-transparent"></div>
        </div>
      )}

      <div className="p-6 max-w-4xl mx-auto min-w-2/3">
        <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">
          <h2 className="text-xl font-bold mb-4 text-[#EF7320]">Upload Bill Image</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="flex items-center gap-4">
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
               
                className="block w-full text-sm text-gray-600
                  file:mr-4 file:py-2 file:px-4
                  file:rounded-full file:border-0
                  file:text-sm file:font-semibold
                  file:bg-[#EF7320] file:text-white
                  hover:file:bg-orange-500"
              />
             
              {file && (
                <img
                  src={URL.createObjectURL(file)}
                  alt="Preview"
                  className="h-35 rounded shadow"
                />

                
              )}
             
            </div>
             
             <button
              type="submit"
              disabled={!file}
              className={`px-6 py-2 rounded-lg transition ${
                file
                  ? 'bg-[#EF7320] text-white hover:bg-orange-500 cursor-pointer'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >
              Submit
            </button>
          </form>
        </div>

        {errorMessage && <div className="text-red-500 mb-4">{errorMessage}</div>}

        {tableData.length > 0 && (
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <h3 className="text-lg font-bold mb-4 text-gray-800">Extracted Bill Details</h3>
            <div className="overflow-y-auto max-h-80">
              <table className="w-full table-auto border-collapse">
                <thead className="bg-[#EF7320] text-white">
                  <tr>
                    <th className="px-4 py-2 text-left">Bill No</th>
                    <th className="px-4 py-2 text-left">Customer Name</th>
                    <th className="px-4 py-2 text-left">Bill Date</th>
                    <th className="px-4 py-2 text-left">Bill Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((item, idx) => (
                    <tr key={idx} className="border-b text-sm text-gray-700 bg-gray-50 hover:bg-gray-100">
                      <td className="px-4 py-2">{item.billNo}</td>
                      <td className="px-4 py-2">{item.customerName}</td>
                      <td className="px-4 py-2">{item.billDate}</td>
                      <td className="px-4 py-2">{item.billAmount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      {/* <div>
        <Ocrsupport />
      </div> */}
      <div>
        <FileUploadHistory refresh={refreshUploads}/>
      </div>
    </Sidebar>
  );
};

export default OCRUpload;
